import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-right-corner",
  "use": "icon-right-corner-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-right-corner\"><path d=\"M962 962l-900 0L62 62A900 900 0 0 0 933.875 961.55L962 962z\" p-id=\"1414\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol